import { render, staticRenderFns } from "./GLYF_Tobe_Expert.vue?vue&type=template&id=1a55fd14&scoped=true"
import script from "./GLYF_Tobe_Expert.vue?vue&type=script&lang=js"
export * from "./GLYF_Tobe_Expert.vue?vue&type=script&lang=js"
import style0 from "./GLYF_Tobe_Expert.vue?vue&type=style&index=0&id=1a55fd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a55fd14",
  null
  
)

export default component.exports